export default {
    product: {
        description: {
            more: "más"
        },
        added: "Añadido al carrito"
    }
}